import { isEmptyObject } from '../../../utils/tests';
import { DataCardCalendarQuery } from '../types';

/**
 * typeguard for DataCardCalendarQuery
 * @param DataCardCalendarQuery object passed to transformer
 */
export const isValidDataCardCalendar = (obj: DataCardCalendarQuery): boolean =>
  Boolean(obj?.data?.getCardCompetitionCalendar && !isEmptyObject(obj.data.getCardCompetitionCalendar));
